import { local } from './local'
import { staging } from './staging'
import { production } from './prod'

let config = local

switch (process.env.PDBD_ENV) {
    case 'staging':
        config = staging
        console.log(JSON.stringify(config))
        break
    case 'production':
        config = production
        break
}

export { config }